module.exports = __webpack_public_path__ + "img/project1_medium.cf18d54b.webp";